import React from 'react';
import EventsCalendar from '../components/ActivitiesCalendar';
import Footer from '../components/Footer';

function EventsCalendarPage() {
  return (
    <>
      <EventsCalendar />
      <Footer />
    </>
  );
}

export default EventsCalendarPage;
